// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiPaper-root.MuiPaper-elevation1.help-center-section {
	padding: 24px;
	border-radius: 24px;
	scroll-margin-top: 80px;
	box-shadow: none;
	border: 1px solid #ebebeb;
}

/* More specific heading selectors */
.MuiPaper-root.help-center-section h1 {
	margin-bottom: 24px;
	margin-top: 0;
}

.MuiPaper-root.help-center-section h2 {
	margin-bottom: 16px;
	margin-top: 0;
}

.MuiPaper-root.help-center-section h3 {
	margin-top: 0;
	margin-bottom: 8px;
}

.MuiPaper-root.help-center-section p {
	margin-bottom: 16px;
	margin-top: 0;
}

.MuiPaper-root.help-center-section ul,
.MuiPaper-root.help-center-section ol {
	padding-left: 20px;
	margin-bottom: 0px;
	margin-top: 0px;
}

.MuiPaper-root.help-center-section li {
	margin-bottom: 4px;
}

.MuiPaper-root.help-center-section strong,
.MuiPaper-root.help-center-section b {
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 152%;
	letter-spacing: 0.15px;
}

.MuiPaper-root.help-center-section em,
.MuiPaper-root.help-center-section i {
	font-style: italic;
}

.MuiPaper-root.MuiPaper-elevation1.help-center-index-section {
	padding: 24px;
	border-radius: 24px;
	box-shadow: none;
	border: 1px solid #ebebeb;
	padding-bottom: 0;
}

.MuiPaper-root.MuiPaper-elevation1.help-center-header-section {
	border-radius: 24px;
	box-shadow: none;
	border: 1px solid #ebebeb;
}

.MuiBox-root.help-center-container {
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.MuiContainer-root.help-center-main-container {
	padding-top: 32px;
	padding-bottom: 32px;
}
.MuiTypography-root.MuiTypography-h2.help-center-header-title {
	font-family: 'Open Sans', sans-serif;
	font-size: 34px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%;
	letter-spacing: -0.5px;
}

.MuiBox-root.help-center-header-title-container {
	width: 56%;
	text-align: left;
}
.MuiBox-root.help-center-header-container {
	position: relative;
	height: 115px;
	border-radius: 24px;
	background-color: lightgray;
	overflow: hidden;
}

.MuiBox-root.help-center-header-container::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	transform: scaleX(-1);
	z-index: 0;
}

.MuiBox-root.help-center-header-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border-top-left-radius: 24px;
	border-bottom-left-radius: 24px;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding-left: 32px;
	clip-path: circle(50% at 23.1% 45%);
	opacity: 0.9;
}

.MuiBox-root.help-center-index-content-container {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}
.MuiLink-root.help-center-index-link {
	text-decoration: none;
	background: none;
	border: none;
	cursor: pointer;
	display: block;
	text-align: left;
	padding: 0;
}
.MuiBox-root.help-center-loading-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: calc(100vh - 60px);
	overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HelpCenterGuideViewer/HelpCenterGuideViewer.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA,oCAAoC;AACpC;CACC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,aAAa;AACd;;AAEA;;CAEC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,oCAAoC;CACpC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,sBAAsB;CACtB,2BAA2B;CAC3B,4BAA4B;CAC5B,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,+BAA+B;CAC/B,UAAU;CACV,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,kBAAkB;CAClB,mCAAmC;CACnC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,YAAY;CACZ,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,0BAA0B;CAC1B,gBAAgB;AACjB","sourcesContent":[".MuiPaper-root.MuiPaper-elevation1.help-center-section {\n\tpadding: 24px;\n\tborder-radius: 24px;\n\tscroll-margin-top: 80px;\n\tbox-shadow: none;\n\tborder: 1px solid #ebebeb;\n}\n\n/* More specific heading selectors */\n.MuiPaper-root.help-center-section h1 {\n\tmargin-bottom: 24px;\n\tmargin-top: 0;\n}\n\n.MuiPaper-root.help-center-section h2 {\n\tmargin-bottom: 16px;\n\tmargin-top: 0;\n}\n\n.MuiPaper-root.help-center-section h3 {\n\tmargin-top: 0;\n\tmargin-bottom: 8px;\n}\n\n.MuiPaper-root.help-center-section p {\n\tmargin-bottom: 16px;\n\tmargin-top: 0;\n}\n\n.MuiPaper-root.help-center-section ul,\n.MuiPaper-root.help-center-section ol {\n\tpadding-left: 20px;\n\tmargin-bottom: 0px;\n\tmargin-top: 0px;\n}\n\n.MuiPaper-root.help-center-section li {\n\tmargin-bottom: 4px;\n}\n\n.MuiPaper-root.help-center-section strong,\n.MuiPaper-root.help-center-section b {\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 152%;\n\tletter-spacing: 0.15px;\n}\n\n.MuiPaper-root.help-center-section em,\n.MuiPaper-root.help-center-section i {\n\tfont-style: italic;\n}\n\n.MuiPaper-root.MuiPaper-elevation1.help-center-index-section {\n\tpadding: 24px;\n\tborder-radius: 24px;\n\tbox-shadow: none;\n\tborder: 1px solid #ebebeb;\n\tpadding-bottom: 0;\n}\n\n.MuiPaper-root.MuiPaper-elevation1.help-center-header-section {\n\tborder-radius: 24px;\n\tbox-shadow: none;\n\tborder: 1px solid #ebebeb;\n}\n\n.MuiBox-root.help-center-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n}\n\n.MuiContainer-root.help-center-main-container {\n\tpadding-top: 32px;\n\tpadding-bottom: 32px;\n}\n.MuiTypography-root.MuiTypography-h2.help-center-header-title {\n\tfont-family: 'Open Sans', sans-serif;\n\tfont-size: 34px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 120%;\n\tletter-spacing: -0.5px;\n}\n\n.MuiBox-root.help-center-header-title-container {\n\twidth: 56%;\n\ttext-align: left;\n}\n.MuiBox-root.help-center-header-container {\n\tposition: relative;\n\theight: 115px;\n\tborder-radius: 24px;\n\tbackground-color: lightgray;\n\toverflow: hidden;\n}\n\n.MuiBox-root.help-center-header-container::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-size: cover;\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n\ttransform: scaleX(-1);\n\tz-index: 0;\n}\n\n.MuiBox-root.help-center-header-overlay {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tborder-top-left-radius: 24px;\n\tborder-bottom-left-radius: 24px;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tpadding-left: 32px;\n\tclip-path: circle(50% at 23.1% 45%);\n\topacity: 0.9;\n}\n\n.MuiBox-root.help-center-index-content-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n}\n.MuiLink-root.help-center-index-link {\n\ttext-decoration: none;\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\tdisplay: block;\n\ttext-align: left;\n\tpadding: 0;\n}\n.MuiBox-root.help-center-loading-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: calc(100vh - 60px);\n\toverflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
